exports = module.exports = require("../../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-717f3d64] .van-cell-group__title{font-size:0.37333rem;}\n[data-v-717f3d64] .van-cell{font-size:0.32rem;}\n.van-icon-wechat[data-v-717f3d64]{color:green;}\n\n", ""]);

// exports
